import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Text property - Definition */
export class DocsBlockTextPropertyDefinition extends DocsBlockPropertyDefinition {
}
